import { FC } from "react";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { Box, Callout, Heading } from "@radix-ui/themes";
import { Loader, OverviewArchive } from "@/components";
import Cover from "@/assets/cover/news.webp";
import i18next from "i18next";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { useTenantEvents } from "../../hooks/useTenantEvents";
import { SingleEventCard } from "../single/SingleEventCard";

interface EventsOverviewProps {
  zoneId?: string;
}

export const EventsOverview: FC<EventsOverviewProps> = ({
  zoneId,
}): JSX.Element => {
  const coverImage = brand?.cover?.news ? brand.cover.news : Cover;
  const { data, loading, error } = useTenantEvents();

  const filteredData = zoneId
    ? data?.filter((event) => event.zone === zoneId)
    : data;

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <OverviewArchive
        headline="Events"
        subtitle={`${i18next.t("news.desc")} ${brand.name}.`}
        disableBadges={loading}
        background={coverImage}
      />
      {error && (
        <Box>
          <Callout.Root color="red">
            <Callout.Icon>
              <ExclamationTriangleIcon />
            </Callout.Icon>
            <Callout.Text>{error.message}</Callout.Text>
          </Callout.Root>
        </Box>
      )}
      <Heading size="4" as="h2" mb="3">
        Discover events
      </Heading>
      {filteredData &&
        filteredData.map((event) => {
          return <SingleEventCard {...event} key={event.slug} />;
        })}
    </>
  );
};

export default EventsOverview;
